import { OPTIONS } from './fixtures';
import { abandonsState, stateOptions } from './states';

const { states } = OPTIONS;

describe('management/EditUser stateOptions', () => {
  it('offers the chosen country’s subdivisions', () => {
    expect(stateOptions(states, 'US', '')).toEqual(states.US);
  });

  it('offers nothing for a country with no subdivisions on file', () => {
    expect(stateOptions(states, 'PR', '')).toEqual([]);
  });

  it('copes with a country it has no entry for', () => {
    expect(stateOptions(states, 'ZZ', '')).toEqual([]);
  });

  // country_code is nullable and most rows are blank, so a state with no country is
  // the common case. Narrowing alone would render the field empty while still holding
  // the value.
  it('includes a state stored against no country, with its proper label', () => {
    expect(stateOptions(states, '', 'TX')).toEqual(
      expect.arrayContaining([{ label: 'Texas', value: 'TX' }]),
    );
  });

  it('borrows the label from whichever country does list the state', () => {
    expect(stateOptions(states, 'CA', 'TX')[0]).toEqual({
      label: 'Texas',
      value: 'TX',
    });
  });

  it('keeps the chosen country’s own options alongside the borrowed one', () => {
    expect(stateOptions(states, 'CA', 'TX')).toEqual(
      expect.arrayContaining(states.CA),
    );
  });

  // Nothing anywhere has a label for it, so the raw value is better than a blank
  // field: it at least shows what the record holds.
  it('falls back to the raw value for a state nothing lists', () => {
    expect(stateOptions(states, 'US', 'ZZ')[0]).toEqual({
      label: 'ZZ',
      value: 'ZZ',
    });
  });
});

describe('management/EditUser abandonsState', () => {
  it('abandons a state the newly chosen country does not have', () => {
    expect(abandonsState(states, 'CA', 'TX')).toBe(true);
  });

  // The case that makes this conditional rather than unconditional: setting the
  // country on a record that has a state and none is completing it, not replacing it.
  it('keeps a state the newly chosen country does have', () => {
    expect(abandonsState(states, 'US', 'TX')).toBe(false);
  });

  it('has nothing to abandon when no state is set', () => {
    expect(abandonsState(states, 'CA', '')).toBe(false);
  });

  // The Country select carries a clear button, and clearing it reports '' like any
  // other change. Abandoning the state here would blank a field the admin never
  // touched, and would do it to exactly the state-with-no-country record that
  // stateOptions goes on rendering.
  it('keeps the state when the country is cleared', () => {
    expect(abandonsState(states, '', 'TX')).toBe(false);
  });

  it('keeps the state when there is no country to compare against', () => {
    expect(abandonsState(states, undefined, 'TX')).toBe(false);
  });
});
